window.openVideo = (id) => {
  const popup = document.getElementById(id);

  if (popup) {
    const closeBtn = popup.querySelector('.close-btn');
    const video = popup.querySelector('video');

    scrollLock.disablePageScroll();
    popup.classList.add('active');

    let iframe = popup.querySelector('iframe');
    if (!iframe) {
      popup.insertAdjacentHTML(
        'beforeend',
        `
        <iframe
          src="https://player.vimeo.com/video/870987464?badge=0&autopause=0&quality_selector=1&progress_bar=1&player_id=0&app_id=58479"
          width="1920"
          height="1080"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          title="Bold Summer 2023 Showreel"
        ></iframe>
      `
      );
      iframe = popup.querySelector('iframe');
    }

    if (video) {
      video.play();
    }

    if (iframe) {
      const vimeoPlayer = new Vimeo.Player(iframe);
      vimeoPlayer.play();
    }

    closeBtn.addEventListener('click', () => {
      popup.classList.remove('active');

      if (video) {
        video.pause();
      }

      if (iframe) {
        iframe.remove();
      }

      scrollLock.enablePageScroll();

      const cursorEl = document.querySelector('.mf-cursor');
      cursorEl?.classList.remove('is-open-vimeo');
    });

    const cursorEl = document.querySelector('.mf-cursor');
    cursorEl?.classList.add('is-open-vimeo');
  }
};
